import { render, staticRenderFns } from "./pnrodeme.vue?vue&type=template&id=265cf4b6"
import script from "./pnrodeme.vue?vue&type=script&lang=js"
export * from "./pnrodeme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports